
import { createSelector } from '@reduxjs/toolkit';
import { get } from 'lodash';
const NAME = 'municipality';

export const isLoading = state => state[NAME].isLoading

export const list = createSelector(
  (state, props) => state[NAME][props.prefix ? `${props.prefix}municipality` : 'municipality'],
  (_list) => _list || {}
)


export const selected = createSelector(
  list,
  (_, props) => props,
  (_list, _props) => _list[+get(_props, 'id')] || {}
)